export default __webpack_public_path__ + "static/media/bg.2a1cef34.png";